import * as React from 'react';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ImageService } from 'src/app/shared/image.service';
import { ImageGalleryView } from './image-gallery.view';
import { ObjectUtils } from 'src/core/utils/object';

interface ImageGalleryControllerProps extends ComponentViewProps<string> {
	mode: ControlMode;
	hideEdit?: boolean;
}
interface State {
	images: ImageGallery[];
	imageAdd?: Uint8Array;
	fileNameAdd?: string;
	fileTypeAdd?: string;
}

@observer
export class ImageGalleryController extends React.Component<ImageGalleryControllerProps, State> {
	@resolve
	private toast: ToastNotifications;

	@resolve
	private service: ImageService;

	constructor(props: Readonly<ImageGalleryControllerProps>) {
		super(props);

		this.state = {
			images: [],
		}
	}

	public componentDidMount() {
		const { model, setBusy } = this.props;
		setBusy(true);
		this.service.getImagesFrom(model)
			.then(res => {
				setBusy(false);
				this.setState({
					images: res
				});
			})
			.catch(error => {
				this.toast.showToast("Delete failed!", ObjectUtils.parseError(error), "error");
				setBusy(false);

			});
	}

	public render() {
		const { images } = this.state
		if (images == null) {
			return null;
		}
		let imageNew = this.convertToString(this.state.imageAdd);
		return (
			<ImageGalleryView
				handleImageDelete={this.handleImageDelete}
				mode={this.props.mode}
				model={images}
				saveImage={this.saveImage}
				onImageChange={this.handleImageChange}
				onCancel={this.onCancel}
                imageAdd={imageNew}
                hideEdit={this.props.hideEdit}
			/>
		);
	}

	private handleImageDelete = async (image: ImageGallery) => {
		const { images } = this.state;
		const { model, setBusy } = this.props;
		try {
			setBusy(true);
			const isDeleted = await this.service.removeImage(model, image.name);
			if (isDeleted) {
				this.setState({ images: images.filter(i => i.id !== image.id) });
			}
		}
		catch (error) {
			this.toast.showToast("Delete failed!", ObjectUtils.parseError(error), "error");
		} finally {
			setBusy(false);
		}
	}
	private onCancel = () => {
		this.setState({
			imageAdd: undefined,
			fileNameAdd: undefined,
			fileTypeAdd: undefined
		});
	}
	private saveImage = async(  title: string, visibility: VisibilityItem) => {
		const { model, setBusy } = this.props;
		const { imageAdd, fileNameAdd, fileTypeAdd } = this.state;
		try {
			setBusy(true);
			const imageGalery = await this.service.addImage(model, fileNameAdd, fileTypeAdd, imageAdd, visibility, title);
			if (imageGalery) {
				this.setState({
					images: [...this.state.images, imageGalery]
				});
			}
		}
		catch (error) {
			this.toast.showToast("Add image failed!", ObjectUtils.parseError(error), "error");
		} finally {
			setBusy(false);
		}


	}
	convertToString(file: Uint8Array): string {
		let str = '';
		if (file != null && file.length > 0) {

			for (let i = 0; i < file.length; i++) {
				str += String.fromCharCode(file[i]);
			}

		}

		return btoa(str);
	}
	private handleImageChange = (ev: React.ChangeEvent<HTMLInputElement>, size: number) => {
		const { model, setBusy } = this.props;
		const file: File = ev.target.files[0];
		if (file) {
			const contentReader = new FileReader();
			if (file.size > size) {
				this.toast.showToast('Image upload error!', `Image too large, has ${file.size} and must be less than ${size / 1024} kilobytes`, 'error');
				return;
			}
			contentReader.onload = async (e: Event) => {
				setBusy(true);
				const result: ArrayBuffer = (e.target as any).result;
				const image = new Uint8Array(result);
				this.setState({
					imageAdd: image,
					fileNameAdd: file.name,
					fileTypeAdd: file.type
				});
				setBusy(false);

			}
			contentReader.readAsArrayBuffer(file);
		}
	}
}




// WEBPACK FOOTER //
// ./src/app/products/image-gallery/image-gallery.controller.tsx